import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_vehicle_types`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_vehicle_types/${id}`, options)
    .then(response => {
      let vehicle_types = jsona.deserialize(response.data);
      delete vehicle_types.links;
      return vehicle_types;
    });
}

function add(vehicle_types) {
  
  console.log(vehicle_types);
  const payload = jsona.serialize({
    stuff: vehicle_types,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_vehicle_types`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(vehicle_types) {
  const payload = jsona.serialize({
    stuff: vehicle_types,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_vehicle_types/${vehicle_types.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_vehicle_types/${id}`, options);
}

function listByBrand(brand) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_vehicle_types?filter[vehicle_brand_id]=${brand}`, options)
    .then(response => {
      let vehicle_types = jsona.deserialize(response.data);
      delete vehicle_types.links;
      return vehicle_types;
    });
}




export default {
  list,
  get,
  add,
  update,
  listByBrand,
  destroy,
};

